export const aboutComparisonPt = {
  'about.problem.requires': 'Requer:',
  'about.problem.onlyfans.body': 'Um criador que ganha $10k/mês perde $24.000 por ano em taxas.',
  'about.problem.onlyfans.requires': 'Conta bancária + KYC',
  'about.problem.throne.body': 'Mais conversão de moeda. Mais atrasos nos saques. Limitado a 10 países.',
  'about.problem.throne.requires': 'Conta bancária + KYC',
  'about.problem.linktree.body': 'Ou pague $40/mês por 0% de taxas. De qualquer forma, ficam com seu dinheiro.',
  'about.problem.linktree.requires': 'Conta bancária + processador de pagamentos',
  'about.problem.kickstarter.body': 'Mais $5K-25K em custos de fulfillment. Financiamento tudo ou nada.',
  'about.problem.kickstarter.requires': 'Conta bancária + KYC + fulfillment',
  'about.problem.indiegogo.body': '5% retido até a entrega. Atrasos de pagamento de 14 dias. Flexível, mas caro.',
  'about.problem.indiegogo.requires': 'Conta bancária + KYC + fulfillment',
  'about.problem.katoa.body': 'Sem taxas. Sem atrasos. Fique com 100% até 31 de dezembro de 2026.',
  'about.problem.katoa.requires': 'Não precisa de conta bancária. Sem KYC.',
  'about.problem.avgLoss': 'O criador médio perde',
  'about.problem.avgLossAmount': '$12.000-$24.000/ano',
  'about.problem.allRequire': 'Todas as 5 plataformas exigem:',
  'about.problem.bankAccount': 'Conta bancária',
  'about.problem.kyc': 'Verificação KYC',
  'about.problem.processors': 'Processadores de pagamento',
  'about.problem.geoLimits': 'Limites geográficos',
  'about.problem.katoaRequires': 'KATOA exige: NADA',
  'about.problem.katoaWallet': 'Apenas uma carteira Bitcoin Lightning. Só isso.',
  'about.solution.title': 'Nossa solução: Bitcoin + descentralização',
  'about.solution.subtitle': 'Construímos o KATOA em tecnologia que torna taxas de plataforma impossíveis.',
  'about.solution.lightning.title': 'Lightning Network',
  'about.solution.lightning.body': 'A Lightning Network do Bitcoin permite transações rápidas e de baixo custo globalmente assim que o recebimento Lightning estiver ativo (Roadmap: em andamento). Sem processador cobrando taxa. Sem atrasos de 7 dias. Sem restrições geográficas.',
  'about.solution.lightning.item1': 'Liquidações em menos de 1 segundo',
  'about.solution.lightning.item2': 'Funciona em mais de 195 países',
  'about.solution.lightning.item3': 'Micropagamentos até satoshis',
  'about.solution.lightning.item4': 'Não precisa de conta bancária',
  'about.solution.nostr.title': 'Protocolo Nostr',
  'about.solution.nostr.body': 'Um protocolo social descentralizado que torna a censura impossível. Sua conta, seus dados, suas regras. Nenhuma empresa pode banir você ou explorar suas informações.',
  'about.solution.nostr.item1': 'Sem suspensões de conta (você possui suas chaves)',
  'about.solution.nostr.item2': 'Mensagens criptografadas opcionais (NIP-17)',
  'about.solution.nostr.item3': 'Provas de pagamento de conhecimento zero (roteiro)',
  'about.solution.nostr.item4': 'Distribuído em relays pelo mundo',
  'about.solution.result.title': 'O resultado: 0% de taxas até 31 de dezembro de 2026',
  'about.solution.result.body': 'Quando os pagamentos fluem peer-to-peer no Bitcoin, não há intermediário extraindo taxas. Não é tarifa promocional. É como a tecnologia funciona.',
  'about.values.title': 'O que defendemos',
  'about.values.creators.title': 'Criadores em primeiro lugar',
  'about.values.creators.desc': 'Cada decisão prioriza os ganhos e a liberdade do criador.',
  'about.values.privacy.title': 'Privacidade sempre',
  'about.values.privacy.desc': 'Coletamos o mínimo. Pagamentos não custodiados. Suas chaves são suas.',
  'about.values.global.title': 'Verdadeiramente global',
  'about.values.global.desc': 'Sem discriminação geográfica. Bitcoin funciona em todo lugar, para todos.',
  'about.values.censorship.title': 'À prova de censura',
  'about.values.censorship.desc': 'Descentralizado por design. Nenhuma empresa pode banir você ou controlar seu conteúdo.',
  'about.competitors.title': 'Por que todos os concorrentes falham',
  'about.competitors.subtitle': 'Todos compartilham o mesmo defeito: dependência dos sistemas bancários tradicionais.',
  'about.competitors.onlyfans.title': 'OnlyFans: 20% de imposto de plataforma',
  'about.competitors.onlyfans.body': 'Um criador que ganha $10K/mês perde $2.000 por mês ($24K/ano). Mais risco de censura da Mastercard/Visa. Mais suspensões sem recurso.',
  'about.competitors.kickstarter.title': 'Kickstarter: pesadelo de fulfillment',
  'about.competitors.kickstarter.body': '5% de plataforma + processamento (em geral ~8–10% no total), mais US$ 5 mil–25 mil+ de fulfillment. Se não atingir a meta, recebe US$ 0.',
  'about.competitors.indiegogo.title': 'Indiegogo: retenções ocultas',
  'about.competitors.indiegogo.body': '8-15% em taxas totais, incluindo 5% retido até a entrega. Financiamento flexível parece bom até segurarem seu dinheiro.',
  'about.competitors.linktree.title': 'Linktree: monetização paga para ganhar',
  'about.competitors.linktree.body': 'Plano gratuito: 10% de taxas. Ou pague $40/mês ($480/ano) por 0%. De qualquer forma, você perde dinheiro só para ter uma página.',
  'about.competitors.throne.title': 'Throne: a conta do 0%',
  'about.competitors.throne.body': 'Anuncia "0% de taxas"; o total típico fica perto de 10%. O 0% de verdade só vale em ~10 países; no resto você paga a diferença.',
  'about.competitors.con.bankKyc': 'Exige conta bancária + KYC',
  'about.competitors.con.payout7': 'Atrasos de pagamento de 7 dias',
  'about.competitors.con.payout14': 'Atrasos de pagamento de 14+ dias',
  'about.competitors.con.censorship': 'Censura de processadores de pagamento',
  'about.competitors.con.countries': 'Limitado a países suportados',
  'about.competitors.con.fulfillment': 'Estresse de envio/fulfillment',
  'about.competitors.con.oneTime': 'Apenas financiamento único',
  'about.competitors.con.holdback': '5% retido até entrega do produto',
  'about.competitors.con.fulfillmentReq': 'Fulfillment obrigatório',
  'about.competitors.con.processor': 'Exige processador de pagamentos',
  'about.competitors.con.geoRestrict': 'Restrições geográficas',
  'about.competitors.con.feesOrSub': '9-10% de taxas ou $480/ano',
  'about.competitors.con.countries50': 'Limitado a 50 países',
  'about.competitors.con.withdraw7': 'Atrasos de saque de 7 dias',
  'about.competitors.con.countries10': 'Limitado a 10 países para 0%',
  'about.competitors.con.conversion': 'Taxas ocultas de conversão de moeda',
  'about.competitors.katoa.title': 'KATOA: a única alternativa real',
  'about.competitors.katoa.body': 'As taxas de rede/roteamento Lightning são pagas pelos apoiadores. Publicaremos qualquer mudança antes de o prazo terminar.',
  'about.competitors.katoa.fee': '0% de taxas de plataforma até 31 de dezembro de 2026',
  'about.competitors.katoa.feeDesc': 'Absorvidas pela Give A Bit e apoio da comunidade',
  'about.competitors.katoa.payout': 'Pagamentos rápidos (Roadmap)',
  'about.competitors.katoa.payoutDesc': 'Via Lightning — assim que a recepção estiver disponível (Roadmap: Em andamento).',
  'about.competitors.katoa.bank': '✓ Sem banco necessário',
  'about.competitors.katoa.bankDesc': 'Apenas uma carteira Lightning.',
  'about.competitors.katoa.global': '✓ Mais de 195 países',
  'about.competitors.katoa.globalDesc': 'Funciona igual em todo lugar.',
  'about.audience.title': 'Quem servimos',
  'about.audience.subtitle': 'O KATOA foi criado para criadores que as plataformas tradicionais ignoram.',
  'about.audience.unbanked.title': 'Os não bancarizados',
  'about.audience.unbanked.body': 'Criadores na Argentina, Nigéria, Venezuela, Vietnã. Países onde Stripe e PayPal não funcionam.',
  'about.audience.unbanked.stat': 'Mais de 195 países suportados',
  'about.audience.privacy.title': 'Os conscientes da privacidade',
  'about.audience.privacy.body': 'Criadores que recusam vigilância. Que querem criptografia de ponta a ponta. Que exigem soberania de dados.',
  'about.audience.privacy.stat': 'Dados mínimos, não custodial',
  'about.audience.ambitious.title': 'Os ambiciosos',
  'about.audience.ambitious.body': 'Criadores que ganham $10k-$100k+ por mês e estão cansados de perder 10-20% em taxas.',
  'about.audience.ambitious.stat': 'Economize $12k-$240k por ano',
  'about.team.title': 'Feito por criadores, para criadores',
  'about.team.body1': 'Somos uma equipe de criadores cansados de perder 10-20% dos ganhos para plataformas. Então construímos algo melhor.',
  'about.team.body2': 'Não temos investimento de venture capital. Não respondemos a investidores que exigem crescimento a qualquer custo. Respondemos aos criadores. Por isso nunca cobraremos taxas.',
  'about.team.promise': 'Nossa promessa',
  'about.team.promise1': 'Nunca cobraremos taxas de plataforma',
  'about.team.promise2': 'Nunca exploraremos seus dados',
  'about.team.promise3': 'Nunca baniremos criadores por conteúdo legal',
  'about.team.promise4': 'Sempre priorizaremos seus ganhos sobre os nossos',
  'about.cta.title': 'Junte-se ao movimento',
  'about.cta.subtitle': 'Ainda no começo. Junte-se e fique com 100% — 0% de taxa de plataforma até 31 de dezembro de 2026.',
  'about.cta.highlight': 'Seja o próximo.',
  'about.cta.start': 'Comece a ganhar 100%',
  'about.cta.compare': 'Ver os números',
  'about.cta.footer': 'Sem taxas. Sem KYC. Sem pegadinhas. Só você ficando com 100%.',
  'comparison.badge': 'Comparação honesta • Sem marketing',
  'comparison.earningsLabel': 'Seus ganhos mensais (USD)',
  'comparison.savingsYearly': 'Com base em ${amount}/mês — isso é ${yearly}/ano de volta no seu bolso.',
  'comparison.savingsVs': 'vs OnlyFans (${onlyfans}) · Throne (${throne}) · Linktree (${linktree})',
  'comparison.adjustCalc': 'Ajustar na calculadora ↓',
  'comparison.breakdown.title': 'Comparação recurso por recurso',
  'comparison.table.feature': 'Recurso',
  'comparison.table.swipe': 'Deslize para ver mais',
  'comparison.card.countries.title': 'Mais de 195 países',
  'comparison.card.countries.body': 'Sem conta bancária? Sem problema. Bitcoin funciona em todo lugar, para todos. Sem discriminação.',
  'comparison.card.countries.throne': 'Throne: ~10 países com 0% de taxas',
  'comparison.card.countries.katoa': 'KATOA: Todos os países, 0% até 31 dez 2026',
  'comparison.card.privacy.title': 'Privacidade real',
  'comparison.card.privacy.body': 'Coletamos o mínimo. Pagamentos não custodiados. Mensagens criptografadas são opcionais (NIP-17). Provas ZK estão no roteiro.',
  'comparison.card.privacy.others': 'Outros: seus dados são o produto deles',
  'comparison.card.privacy.katoa': 'KATOA: não custodial, dados mínimos',
  'comparison.card.instant.title': 'Liquidação rápida (Roadmap)',
  'comparison.card.instant.body': 'Fique com 100% dos seus ganhos. Escale globalmente. Construa seu império sem impostos de plataforma.',
  'comparison.card.instant.others': 'Outros: espere 7-14 dias pelos pagamentos',
  'comparison.card.instant.katoa': 'KATOA: Lightning Network instantâneo (com recepção Lightning — ver Roadmap)',
  'comparison.cta.title': 'Pronto para ficar com 100%?',
  'comparison.cta.subtitle': 'Entre cedo. 0% de taxa de plataforma. Fique com o que os apoiadores enviarem — as taxas da Lightning ainda existem.',
  'comparison.cta.start': 'Comece a ganhar 100%',
  'comparison.cta.pricing': 'Ver preços (spoiler: $0)',
  'comparison.cat.fees': 'Taxas e custos',
  'comparison.cat.banking': 'Requisitos bancários',
  'comparison.cat.global': 'Alcance global',
  'comparison.cat.payout': 'Velocidade de pagamento',
  'comparison.cat.revenue': 'Modelos de receita',
  'comparison.cat.privacy': 'Privacidade e segurança',
  'comparison.cat.payment': 'Recursos de pagamento',
  'comparison.cat.control': 'Controle da plataforma',
  'comparison.feat.platformFees': 'Taxas de plataforma',
  'comparison.feat.paymentProcessing': 'Processamento de pagamentos',
  'comparison.feat.totalFee10k': 'Taxa total sobre $10K',
  'comparison.feat.monthlySub': 'Assinatura mensal',
  'comparison.feat.withdrawalFees': 'Taxas de saque',
  'comparison.feat.hiddenCosts': 'Custos ocultos',
  'comparison.feat.bankRequired': 'Conta bancária obrigatória',
  'comparison.feat.kyc': 'Verificação KYC/identidade',
  'comparison.feat.noBanking': 'Funciona sem banco',
  'comparison.feat.processorDep': 'Dependente de processador de pagamentos',
  'comparison.feat.countries': 'Países suportados',
  'comparison.feat.sanctioned': 'Bitcoin é global',
  'comparison.feat.instantIntl': 'Transferências internacionais rápidas (Roadmap)',
  'comparison.feat.conversion': 'Taxas de conversão de moeda',
  'comparison.feat.payoutTime': 'Tempo de pagamento',
  'comparison.feat.instantSettlement': 'Liquidação rápida (Roadmap)',
  'comparison.feat.holdback': 'Retenção de fundos',
  'comparison.feat.crowdfunding': 'Crowdfunding/projetos',
  'comparison.feat.subscriptions': 'Assinaturas (demo)',
  'comparison.feat.tips': 'Gorjetas/doações',
  'comparison.feat.digital': 'Produtos digitais',
  'comparison.feat.fulfillment': 'Fulfillment obrigatório',
  'comparison.feat.zk': 'Provas de conhecimento zero (roteiro)',
  'comparison.feat.encrypted': 'Mensagens criptografadas (NIP-17 opcional)',
  'comparison.feat.decentralized': 'Infraestrutura descentralizada',
  'comparison.feat.censorship': 'Resistente à censura',
  'comparison.feat.micro': 'Suporte a micropagamentos',
  'comparison.feat.bolt12': 'BOLT 12 recorrente (previsto)',
  'comparison.feat.lightning': 'Lightning Network',
  'comparison.feat.multiRevenue': 'Múltiplas fontes de receita',
  'comparison.feat.suspension': 'Risco de suspensão de conta',
  'comparison.feat.contentCensor': 'Censura de conteúdo',
  'comparison.feat.ownData': 'Possui seus dados',
  'comparison.feat.ownKeys': 'Possui suas chaves',

  'comparison.cell.instant': 'Rápido',
  'comparison.cell.none': 'Nenhum',
  'comparison.cell.varies': 'Varia',
  'comparison.cell.included': 'Incluído',
  'comparison.cell.limited': 'Limitado',
  'comparison.cell.demo': 'Demo',
  'comparison.cell.planned': 'Previsto',
  'comparison.cell.roadmap': 'Roteiro',

  'comparison.metaTitle': 'Comparação de plataformas',
  'comparison.metaDesc': 'Compare KATOA com OnlyFans, Throne, Kickstarter e mais. 0% de taxa da plataforma, liquidação Lightning, sem KYC para começar.',
} as const;